var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1424,
    height: 153,
    viewBox: "0 0 1424 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1117.53 153H1118V152.66L1117.53 153Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.57 36H161.57C161.57 36 173.14 36 173.14 47H223.67C223.67 35.41 223.67 0 176.67 0H47C0 0 0 35.41 0 47V106.3C0 118 0 153 46.66 153H222V59H105V95H175V118H57.75C57.75 118 46 118 46 106.5V47C46 36 57.57 36 57.57 36Z",
    fill: "#7f8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366 0L272.4 153H319L340.74 118H449.65L471.17 153H518L424.4 0H366ZM362.29 82L395.1 28.56L428.1 82H362.29Z",
    fill: "#7f8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.5 115L627.45 0H569V153H616V58.07L674.48 153H732.74L791 58.07V153H838V0H779.55L703.5 115Z",
    fill: "#7f8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908 153H1130V118H955V95H1130V59H955V36H1130V0H908V153Z",
    fill: "#7f8a9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.26 85.51L1422 36V0H1200V36H1358.3L1327.3 59H1200V153H1266.51L1306.37 123L1311.05 119.48L1322.64 110.76L1364.8 153H1423.6L1356.26 85.51ZM1242 123V90H1286.11L1279.43 95L1248.69 118L1246.98 119.28L1241.98 123H1242Z",
    fill: "#7f8a9d"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1423.6,
    height: 153,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGrey);
export default __webpack_public_path__ + "static/media/logo-grey.165b6f1a2b094cf85c0dedad038757d0.svg";
export { ForwardRef as ReactComponent };